import * as React from 'react';

type InfiniteScrollContextValue = {
  canLoadMore?: boolean;
  isLoadingMore?: boolean;
  loadMoreItems?: () => void;
  loadingMoreText?: string;
  itemHeight: number;
  listHeight: number;
  overscan: number;
  loadMoreThreshold: number;
};

const InfiniteScrollContext = React.createContext<InfiniteScrollContextValue | null>(
  null,
);

function useInfiniteScrollContext(): InfiniteScrollContextValue {
  const ctx = React.useContext(InfiniteScrollContext);
  if (!ctx) {
    throw new Error(
      'useInfiniteScrollContext must be used within an InfiniteScrollContext.Provider',
    );
  }
  return ctx;
}

export {InfiniteScrollContext, useInfiniteScrollContext};
export type {InfiniteScrollContextValue};
